import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { PERMISSION_SUPPLIER } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import SuppliersForm from '../../components/OperationCosts/Suppliers/SuppliersForm';
import { URL_SUPPLIERS } from '../../router/constants';

const editSupplierSearchSchema = z.object({
  customerId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/suppliers/edit/$id')({
  validateSearch: editSupplierSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_SUPPLIER, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.suppliersOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditSupplierRoute,
});

function EditSupplierRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_SUPPLIERS });
  }, [navigate]);

  return (
    <SuppliersForm
      isEdited={true}
      closeCallback={handleClose}
      selectedId={Number(id)}
      customerIds={search.customerId ?? null}
    />
  );
}
